module.exports = [
    {
        id: 'matched-promotion',
        content: require('./matched-promotion.html').trim()
    },
    {
        id: 'missed-promotion',
        content: require('./missed-promotion.html').trim()
    },
    {
        id: 'error-quantity',
        content: require('./error-quantity.html').trim()
    }
];


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/collectionzone/inline-messages/index.js
 **/